var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cgv-page" }, [
      _c("div", { staticClass: "container" }, [
        _c("h2", { staticClass: "text-center mb-4" }, [
          _vm._v(
            "Conditions générales d’utilisation\n            du service en ligne de gestion des Certificats Restreints de Radiotéléphoniste (CRR)"
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Définition et objet du service en ligne :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "L’Agence nationale des fréquences (ANFR) gère pour le compte du Ministère de la Transition Ecologique et Solidaire (MTES), les examens aux certificats restreints de\n            radiotéléphoniste (CRR) maritimes et fluviaux qui sont requis pour utiliser une station radiotéléphonique de navire, appelée VHF conformément à l’arrêté du 18 mai\n            2005\n            modifié."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Le service en ligne CRR vous permet de vous inscrire à une session d’examen et d’acquitter en ligne les droits d’examen."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "L’utilisation du Service est subordonnée à l’acceptation par l’usager des présentes conditions générales d’utilisation (dites « CGU »)."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Ces CGU sont rédigées en application de l’article 4 de l’ordonnance n°2005-1516 du 8 décembre 2005 relative aux échanges électroniques entre les usagers et les\n            autorités administratives et entre les autorités administratives."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Disponibilités et évolution du Service :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Le service est disponible 7 jours sur 7 et 24 heures sur 24. L’ANFR se réserve toutefois la faculté de faire évoluer, de modifier ou de suspendre, sans préavis, le\n            service pour des raisons de maintenance ou pour tout autre motif jugé nécessaire. L’indisponibilité du service ne donne droit à aucune indemnité."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les termes des présentes CGU peuvent être amendés à tout moment, sans préavis, en fonction des modifications apportées au service, de l’évolution de la législation\n            ou\n            pour tout autre motif jugé nécessaire."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Engagements et responsabilités :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "L’usager ou demandeur du service s’engage à ne fournir que des informations exactes, à jour et complètes. La loi punit quiconque se rend coupable de fraudes ou de\n            fausses déclarations."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "L’article 441-6 du code pénal punit de deux ans d’emprisonnement et de 30 000 euros d’amende le fait de fournir une déclaration mensongère en vue d’obtenir d’une\n            administration publique ou d’un organisme chargé d’une mission de service public une allocation, un paiement ou un avantage indu."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Propriété intellectuelle :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Le service est une œuvre de création, propriété exclusive de l’ANFR, protégé par le droit de la propriété intellectuelle. Aucune reproduction ou représentation ne\n            peut\n            être réalisée en contravention avec les droits de la propriété intellectuelle de l’ANFR."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Cookies :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Quand l’usager se connecte au service en ligne, un cookie « identifiants de session » est installé sur son terminal."
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Protection des données personnelles :")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les données personnelles collectées dans ce Service font l’objet d’un traitement informatique par l’ANFR en qualité de sous-traitant du Ministère de la Transition\n            Ecologique et Solidaire (MTES), responsable du traitement, aux fins de la gestion des certificats restreints de radiotéléphoniste (CRR) maritimes ou fluviaux\n            délivrés\n            en France métropole et dans les DOM. Elles peuvent être communiquées aux personnes habilitées de l’ANFR et des directions concernées du MTES."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Les données traitées sont conservées pour la durée de vie du dossier, à l’exception des données de paiement par Carte Bancaire qui sont conservées 1 mois (numéro\n            obfusqué), la photocopie de la carte d’identité du candidat qui est détruite dans les 3 ans à compter de sa réception."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Le traitement est nécessaire aux fins d’une mission d’intérêt public relative à la gestion des certificats CRR sur la base d’une convention conclue entre l’ANFR et\n            le\n            MTES (articles L42-4 et R20-44-11 11° CPCE)."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Conformément au règlement européen 2016/679 du 27 avril 2016, vous bénéficiez du droit d’accès, de rectification, d’effacement, d’opposition, du droit à la\n            limitation\n            du traitement. Vous pouvez également nous transmettre des directives particulières concernant la conservation, l'effacement et la communication de vos données à\n            caractère personnel après votre décès."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Vous pouvez exercer ces droits en contactant le délégué à la protection des données à l’adresse suivante : "
          ),
          _c("a", { attrs: { href: "mailto:dpo@anfr.fr" } }, [
            _vm._v("dpo@anfr.fr")
          ]),
          _vm._v(".")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Vous pouvez introduire une réclamation auprès de la CNIL.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }